export const MODIFY_AMOUNT = {
  titleRadiobutton: '¿Cómo deseas ahorrar?',
  titleAmountInput: '¿Cuánto deseas ahorrar?',
  placeHolderAmountInput: 'Ingresa un monto',
  placeHolderPercentageInput: 'Ingresa un porcentaje de tu sueldo',
};
export const CURRENCY = {
  pesos: 'Peso',
  uf: 'UF',
  porcentaje: 'Porcentaje de tu sueldo'
};
